import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';
// import { COLOR } from '@src/styles/color';

const StyledDialog = styled(Dialog)`
  min-width: ${(props) => props.width || 'auto'};

  .MuiDialog-paper {
    border-radius: 16px;
    margin: 16px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
  }

  .dialog-wrapper {
    gap: 22px;
  }

  .dialog-title {
    display: flex;
    gap: 8px;
    align-items: center;

    .icon {
      width: 24px;
      height: 24px;
    }

    .title {
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: -0.4px;
      color: ${COLOR.darkBlue};
    }
  }

  .dialog-message {
    padding: 12px 24px;

    .title-message {
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 28px; /* 140% */
      letter-spacing: -0.4px;
      margin-bottom: 8px;
    }

    .description {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.4px;
      /* margin-left: 16px; */
    }
  }

  .content-wrapper {
    margin-bottom: 14px;
  }

  .btn-understood {
    margin-right: 24px;
    min-width: 120px;
    padding: 8px 12px;
    border-radius: 32px;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    text-transform: none;
  }

  .cancel-btn {
    border-color: ${COLOR.secondary[32]};
  }

  .non-vbee-warning {
    margin-left: 24px;
    width: 100%;
    display: flex;
    padding: 0 5px;
    justify-content: space-between;
    align-items: center;

    .not-show-again-text {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }

    .btn-non-vbee-warning {
      padding: 10px 24px;
      margin-right: 8px;
      border-radius: 12px;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      text-transform: none;
    }
  }

  .used-credits-button-container {
    margin: -8px 12px 8px auto;
    .button-got-it {
      border-radius: 12px;
      text-transform: none;
      color: ${COLOR.darkBlue};
      font-weight: 600;
    }
  }

  .cancel-auto-renew-buttons-container {
    display: flex;
    color: ${COLOR.darkBlue};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.4px;
    width: 90%;
    margin: 0 auto;
    gap: 24px;

    .agree {
      flex: 1;
      border: 1px solid rgba(30, 22, 78, 0.32);
      box-sizing: border-box;
      border-radius: 500px;
      text-transform: none;
    }

    .disagree {
      border-radius: 500px;
      background: ${COLOR.primary};
      flex: 1;
      text-transform: none;
    }
  }

  @media only screen and (max-width: 768px) {
    .header {
      padding: 6px 16px;
    }

    .dialog-title {
      display: flex;
      gap: 8px;
      align-items: center;

      .icon {
        width: 24px;
        height: 24px;
      }

      .title {
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: -0.4px;
      }
    }

    .dialog-wrapper {
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }

    .dialog-title {
      text-align: left;
      font-weight: 700;
    }

    .dialog-action {
      justify-content: center;
      align-items: center;
      gap: 10px;
    }

    .dialog-message {
      padding: 12px 30px;

      .title-message {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
        letter-spacing: -0.4px;
      }

      .description {
        font-size: 14px;
        margin-left: 0px;
      }
    }

    .cancel-auto-renew-buttons-container {
      gap: 12px;
    }

    .content-wrapper {
      margin-bottom: 4px;
    }

    .btn-understood {
      width: 100%;
      margin: 0px 4px;
      padding: 8px;
      font-size: 14px;
    }

    .non-vbee-warning {
      margin-top: -14px;
      margin-left: 0px;
      width: 100%;
      display: block;

      .not-show-again-text {
        font-size: 14px;
        color: ${COLOR.darkBlue};
        font-style: normal;
        font-weight: 400;
      }

      .btn-group {
        margin-top: 8px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
      }

      .btn-non-vbee-warning {
        margin-right: 8px;
        border-radius: 12px;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
        text-transform: none;
        width: 100%;
      }
    }
  }
`;
export { StyledDialog };
